/* eslint-disable no-param-reassign */
export default {
    /**
     * @override
     */
    SET_COUNTRIES(state, countries) {
        state.countries = countries;
    }
};
